export default (tag, props = {}) => {
    const node = document.createElement(tag)
    Object.entries(props).forEach(([key, value]) => node[key] = value)

    return node
}
